var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Heart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,54c-0.282,0 -0.564,-0.06 -0.826,-0.179c-12.995,-5.898 -23.174,-18.434 -23.174,-28.54c0,-7.323 5.965,-13.281 13.297,-13.281c4.098,0 7.688,1.871 10.703,5.571c3.016,-3.7 6.605,-5.571 10.703,-5.571c7.332,0 13.297,5.958 13.297,13.281c0,10.105 -10.179,22.642 -23.174,28.54c-0.262,0.119 -0.544,0.179 -0.826,0.179zM21.297,16c-5.126,0 -9.297,4.164 -9.297,9.281c0,7.267 7.622,18.558 20,24.511c12.378,-5.953 20,-17.244 20,-24.511c0,-5.117 -4.171,-9.281 -9.297,-9.281c-3.479,0 -6.428,1.985 -9.014,6.07c-0.366,0.579 -1.003,0.93 -1.689,0.93c-0.686,0 -1.323,-0.351 -1.689,-0.93c-2.586,-4.085 -5.535,-6.07 -9.014,-6.07z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Heart);
export default __webpack_public_path__ + "static/media/icons8-heart.75708c756568af4c57dc11570ab37b20.svg";
export { ForwardRef as ReactComponent };